import { Injectable } from '@angular/core';
import { uniq } from 'lodash';
import { toParams } from '@shared/utils/query-to-params';
import { Observable } from 'rxjs';
import { EmbedReport, Report, embed, configuration } from '../models/report.model';
import { HttpClient } from '@angular/common/http';
import { ErrorService } from '@app/services/error.service';
import { catchError, map } from 'rxjs/operators';
import { Embedded } from '@data/models/embed.model';
import { FilterParams } from '@claranet/node-search-filter';

const REPORT_BASE_URL = '/reporting/v1';

@Injectable()
export class ReportService {

    private errors;

    constructor(
        private errorService: ErrorService,
        private http: HttpClient
    ) {
        this.errors = this.errorService.roleServiceErrors;
    }

    public addProjectReport({ project, report }: { project: string; report: string }, options?: { shouldThrowError?: boolean }): Observable<Report> {
        return this.http.post<Report>(`${REPORT_BASE_URL}/projects/${project}/reports/${report}:assignProject`, undefined)
            .pipe(
                map((r) => new Report(r)),
                catchError(this.errorService.errorHandler<Report>(this.errors, 'Mise à jour du rapport', null, options?.shouldThrowError)),
            );
    }

    public removeProjectReport({ report, project }: { project: string; report: string }, options?: { shouldThrowError?: boolean }): Observable<Report> {
        return this.http.post<Report>(`${REPORT_BASE_URL}/projects/${project}/reports/${report}:removeProject`, undefined)
            .pipe(
                map((r) => new Report(r)),
                catchError(this.errorService.errorHandler<Report>(this.errors, 'Mise à jour du rapport', null, options?.shouldThrowError)),
            );
    }

    public getReports<T extends embed>(filterParams: FilterParams, embedFields: T[] = []): Observable<EmbedReport<T>[]> {
        const embeds = uniq(embedFields.map((it) => configuration[it].embed)).join(',');
        const params = toParams({ ...filterParams, embed: embeds });

        return this.http.get<{ reports: Report[]; embedded: Embedded }>(`${REPORT_BASE_URL}/reports`, { params }).pipe(
            map(({ reports, embedded }) => reports.map((report) => Report.toEmbeddedReport(report, embedded, embedFields))),
            catchError(this.errorService.errorHandler<EmbedReport<T>[]>(this.errors, 'Récupération des rapports', []))
        );
    }

}

